import React, { useContext, useEffect, useState } from 'react'

const SlidItemsSelect = (props) => {

    const [slideItem, setSlideItem] = useState(props.slideItem);
    const [selectionType, setSelectionType] = useState(props.slideItem.selectionType);

    useEffect(() => {
        setSlideItem(props.slideItem);
    }, [props.slideItem])


    const handleChange = (e) => {
        setSelectionType(e.target.value)
        props.changeSectionSelectionType(e.target.value)
    }

    return (
        <span className={`prodFirst`}>
            <label>אופן תצוגת הפריטים</label>
            <select
                className={``}
                value={selectionType}
                onChange={handleChange}>
                <option value={"1"}>רנדומלי</option>
                <option value={"2"}>לפי מחלקות</option>
                <option value={"3"}>סדר רגיל</option>
            </select>
        </span>
    )
}

export default SlidItemsSelect;
